const screenModes = {
  Desktop: "ScreenMode.Desktop",
  Tablet: "ScreenMode.Tablet",
  MobilePortrait: "ScreenMode.MobilePortrait",
  MobileLandscape: "ScreenMode.MobileLandscape"
};

export const isScreenModeMobile = mode => mode === screenModes.MobileLandscape || mode === screenModes.MobilePortrait;

export default screenModes;
